export const NOTES_TASK_FILTERS = 'NOTES_TASK_FILTERS';
export const NOTES_TASK_FILTERS_HC = 'NOTES_TASK_FILTERS_HC';
export const NOTES_TASK_FILTERS_SC = 'NOTES_TASK_FILTERS_SC';